module.exports = __webpack_public_path__ + "static/media/invitation.ea5fd77a.svg";